import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useUserInvitationsState() {
  return useAppState();
}

export function useUserInvitationsActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      newOpenUserInvitation: {
        firstName: '',
        lastName: '',
        email: '',
      },
      openUserInvitations: [],
      userInvitationRequests: [],
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function updateFirstName(firstName) {
    dispatch((appState) => ({
      ...appState,
      newOpenUserInvitation: {
        ...appState.newOpenUserInvitation,
        firstName: firstName,
      }
    }));
  }

  function updateLastName(lastName) {
    dispatch((appState) => ({
      ...appState,
      newOpenUserInvitation: {
        ...appState.newOpenUserInvitation,
        lastName: lastName,
      }
    }));
  }

  function updateEmail(email) {
    dispatch((appState) => ({
      ...appState,
      newOpenUserInvitation: {
        ...appState.newOpenUserInvitation,
        email: email,
      }
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    updateFirstName,
    updateLastName,
    updateEmail,
    clearFeedback,
  };
}
